<template>
    <div id="app">
        <header>
            <div class="main">
                <div class="logo">小程序{{`${bus.smallAppName ? '-' : ''}`}}{{bus.smallAppName}}</div>
                <div class="parent-nav" v-if="bus.username && !bus.smallAppName && bus.type !== 'up'">
                    <span @click="active(0)" :class="{activeNav: navActive[0]}">
                    <router-link to="/index">首页</router-link></span>
                    <span @click="active(1)" :class="{activeNav: navActive[1]}">
                    <router-link to="/payCenter">支付中心</router-link></span>
                </div>
                <div class="right-content" v-if="bus.username || bus.code === 83001003">
                    <span class="skip-manage" @click ='skipToNewManage'>前往新平台</span>
                    <span class="default-avatar"></span>
                    <span class="username">{{bus.username}}</span>
                    <span @click="logout" class="logout">退出</span>
                </div>
            </div>
        </header>
        <router-view class="main-content-pay" v-if="navActive[1]"></router-view>
        <router-view class="main-content" v-else></router-view>
    </div>
</template>

<script>
import bus from '@/lib/bus';
import dao from '@/lib/dao';
export default {
    data() {
        return {
            bus: {
                appName: '',
                smallAppName: '',
                username: ''
            },
            navActive: [],
            activeIndex: 0,
            path: ['index', 'payCenter']
        }
    },
    watch: {
        '$route' (to, from) {
            let index = 0;
            for (; index < this.path.length; index++) {
                if (to.path.indexOf(this.path[index]) >= 0) {
                    this.$set(this.navActive, this.activeIndex, false);
                    this.$set(this.navActive, index, true);
                    this.activeIndex = index;
                }
            }
        }
    },
    methods: {
        skipToNewManage(){
             window.open('https://miniapp.bilibili.com/developer-open/home','_blank');
        },
        logout() {
            dao.logout().then(_ => {
                if (bus.type == 'up') {
                    if (this.$route.path === '/up/manage') {
                        this.$router.go(0);
                    } else if (this.$route.path === '/up/preview') {
                        location.href = location.href.replace(location.hash, '') + '#/index';
                    }
                } else  {
                    if (this.$route.path === '/index') {
                        this.$router.go(0);
                    } else {
                        location.href = location.href.replace(location.hash, '') + '#/index';
                    }
                }
                this.bus = {};
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        active(index) {
            this.navActive[this.activeIndex] = false;
            this.navActive[index] = true;
            this.activeIndex = index;
        },
        getInfo() {
            dao.shop.getCompanyInfo().then(data => {
                this.bus.username = data;
                this.bus.smallAppName = bus.smallAppName;
            }).catch(response => {
                if (response.code === 83001002) {
                    this.logined = false;
                } else if (response.code !== 83001003) {
                    this.$message.error(response.message);
                }
            });
        }
    },
    mounted() {
        this.bus = bus;
        let path = this.$route.path;
        this.navActive.length = this.path.length;
        this.path.forEach((item, index) => {
            if (path.indexOf(`${item}`) >= 0) {
                this.$set(this.navActive, index, true);
                this.activeIndex = index;
            } else {
                this.$set(this.navActive, index, false);
            }
        });
        window.location.href = window.location.href.replace(/mall\.bilibili\.com/, 'miniapp.bilibili.com');
    }
}
</script>

<style lang="less">
body {
    font-family: -apple-system-font,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif;
    margin: 0;
    background: #F7F8FB;
    -webkit-font-smoothing: antialiased;
}
header {
    min-width: 1180px;
    background-color: #687FB7;
    height: 60px;

    .main {
        line-height: 60px;
        color: #fff;
        height: 60px;
        width: 1180px;
        margin: 0 auto;
        position: relative;

        .logo {
            display: inline-block;
            height: 60px;
            background: url(./assets/logo.png) 0 center no-repeat;
            background-size: 62px 38px;
            padding-left: 68px;
        }
        .right-content {
            position: absolute;
            right: 0;
            top: 0;
            color: #fff;
            font-size: 0;
            line-height: 60px;
            font-size: 14px;
            .default-avatar {
                display: inline-block;
                width: 17px;
                height: 17px;
                background: url(./assets/nav.png) center / 17px;
                margin-right: 10px;
                vertical-align: middle;
            }
            .skip-manage{
                margin-right: 20px;
                cursor: pointer;
            }
            .username {
                vertical-align: text-bottom;
                line-height: 17px;
                vertical-align: middle;
            }
            .logout {
                vertical-align: middle;
                margin-left: 10px;
                border-left: 1px solid;
                padding-left: 10px;
                cursor: pointer;
            }
        }

        .parent-nav {
            display: inline-block;
            height: 60px;
            line-height: 60px;
            vertical-align: top;
            margin-left: 20px;

            a {
                padding: 44px 20px;
                font-size: 16px;
                text-decoration: none;
                cursor: pointer;
                color: #FFFFFF;
            }
            span {
                display: inline-block;
                height: 60px;
            }
            .activeNav {
              background-color: #5d72a4!important;
            }
        }
    }
}
.main-content {
    width: 1180px;
    margin: 20px auto 0 auto;
}
.main-content-pay {
    width: 1280px;
    margin: 0 auto;
}

p {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue